import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=8542c366&scoped=true"
import script from "./RoomType.vue?vue&type=script&lang=js"
export * from "./RoomType.vue?vue&type=script&lang=js"
import style0 from "./RoomType.vue?vue&type=style&index=0&id=8542c366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8542c366",
  null
  
)

export default component.exports